<template>
  <div class="editor">
    <!-- bidirectional data binding（双向数据绑定） -->
    <a-spin
      :spinning="imageLoading"
      :tip="loadTip"
      @paste="handlePaste"
    >
      <quill-editor
        ref="myQuillEditor"
        v-model="value"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
        @change="onEditorChange($event)"
      />
      <a-upload
        ref="button"
        name="file"
        :headers="{ 'X-Requested-With': null }"
        :show-upload-list="false"
        :before-upload="beforeUpload"
        multiple
        accept="image/*"
        :action="action"
        :data="getOtherParams"
        class="hide"
        @change="uploadChangeHandle"
      />
    </a-spin>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
  <!-- Or manually control the data synchronization（或手动控制数据流） -->
  <!-- <quill-editor
    :content="content"
    :options="editorOption"
    @change="onEditorChange($event)"
  /> -->
</template>

<script>
import axios from 'axios'
import { upyunUpload, apiDomain } from '@/lib/config'
import { uploadSignature, uploadConvert } from '@/services/index'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    quillEditor
  },
  inject: {
    myForm: {
      default: () => ({})
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: Number,
      default: 160
    }
  },
  data () {
    let spaceStr = this.$isEnglish ? ' ' : ''
    return {
      // value: this.data.fieldvalue || '',
      value: this.$filterXss.process(this.data.fieldvalue) || '',
      others: {},
      action: upyunUpload,
      pasteFiles: [],
      imageLoading: false,

      editorOption: {
        placeholder: `${this.$t('message["751"]')}${spaceStr}${(this.data && this.data.fieldname) || ''}`,
        modules: {
          /* toolbar: [
            [{ 'font': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['link', 'image']
          ] */
          toolbar: [
            ['image']
          ]
        }
      }
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor && this.$refs.myQuillEditor.quill
    },
    loadTip () {
      return this.$t('message["1225"]')
    }
  },
  // 移动端我的便签需要
  watch: {
    data (newValue, oldValue) {
      // this.value = newValue.fieldvalue
      this.value = this.$filterXss.process(newValue.fieldvalue)
    }
  },

  mounted () {
    const vm = this
    const imgHandler = async (state) => {
      if (state) {
        try {
          this.$refs.button.$refs.uploadRef.$el.click()
        } catch (err) {
          console.log('err: ', err)
        }
      }
    }
    vm.$refs.myQuillEditor && vm.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', imgHandler)

    // 富文本失去焦点事件
    this.$bus.$on('myQuillEditorBlur', this.onEditorBlur)
  },
  // manually control the data synchronization
  // 如果需要手动控制数据同步，父组件需要显式地处理changed事件
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    onEditorBlur (quill) {
      this.$emit('change', this.value)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.value = html

      this.data.fieldvalue = html
    },
    getOtherParams () {
      return this.others
    },
    beforeUpload (file) {
      const vm = this
      const { name: filename } = file
      const type = filename && filename.split('.')[1]

      if (file.type && file.type.indexOf('image') === -1) {
        this.$selefToast({ type: 'error', text: this.$t('message["1599"]') })
        return false
      }
      if (type === 'php') {
        this.$message.error(this.$t('message["1599"]'))
        return false
      }

      this.showLoadingMask().show()

      return new Promise(async (resolve, reject) => {
        const chain = await uploadSignature()
        await chain
          .config({
            tip: false
          })
          .params({
            filename: [filename]
          })
          .onSuccess(async ([detail = {}]) => {
            const { policy, signature } = detail
            vm.others = {
              policy,
              signature
            }
            resolve()
          })
          .fetch()
      })
    },
    showLoadingMask (txt = this.$t('message["994"]')) {
      const toast = this.$createToast({
        txt,
        time: 0
      })
      return toast
    },
    async uploadChangeHandle (info) {
      const vm = this
      const { file } = info
      if (file.status === 'done') {
        const { response } = file
        const { url } = response
        if (url) {
          vm.showLoadingMask().hide()
          const chain2 = uploadConvert()
          await chain2
            .params({
              url
            })
            .onSuccess(payload => {
              /* const ins = vm.$refs.myQuillEditor.quill
              vm.addImgRange = ins.getSelection()
              ins.insertEmbed(
                ins.getSelection(),
                'image',
                payload
              ) */
              const ins = vm.$refs.myQuillEditor.quill
              const index = (ins.getSelection() || {}).index || ins.getLength() - 1
              ins.insertEmbed(index, 'image', payload)
              setTimeout(() => {
                ins.setSelection(index + 1)
              }, 0)

              vm.$selefToast({ type: 'success', text: this.$t('message["988"]') })
            })
            .onFail(() => {
              vm.$selefToast({ type: 'error', text: this.$t('message["989"]') })
            })
            .fetch()
        }
      } else if (info.file.status === 'error') {
        console.log('error')
      }
    },

    // 复制事件
    handlePaste (event) {
      this.pasteFiles = []
      const items = (event.clipboardData || window.clipboardData).items

      let file = null

      if (!items || items.length === 0) {
        this.$selefToast({ type: 'error', text: this.$t('message["163"]') })
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          event.preventDefault()

          this.imageLoading = true
          file = items[i].getAsFile()
          this.pasteFiles.push(file)

          this.pasteUpload(file)
        }
      }
    },

    // 复制图片/截图上传到又拍云
    pasteUpload (file) {
      if (!file) return
      let vm = this
      this.errorCount = 0
      this.successCount = 0
      // let i = this.filesList.length
      if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
        this.$selefToast({ type: 'error', text: this.$t('message["72"]') })
        this.errorCount++
      }

      axios.post(`${apiDomain}/upload/signature`, {
        'filename': [file.name] // 文件本地路径
      }).then(res => {
        // vm.compressorUploadFile(file, res.data.payload)
        vm.uploadFile(file, res.data.payload)
      })
    },
    /*  文件上传 */
    fileUpload (url, params, res) {
      axios.post(url || `http://v0.api.upyun.com/westartrack-file`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        if (data.data.code === 200) {
          this.insertPasteImg(res[0].domain + res[0]._upt)

          this.successCount++
        } else {
          this.errorCount++
        }
        if (this.successCount + this.errorCount >= this.pasteFiles.length) {
          setTimeout(() => {
            if (this.errorCount) {
              this.$selefToast({ type: 'success', text: this.$t('message["991"]') + '，' + this.errorCount + '个文件由于过大上传失败。' })
            } else {
              this.$selefToast({ type: 'success', text: this.$t('message["991"]') })
            }
          }, 100)
        }
      })
    },
    // 后端参数压缩上传
    async uploadFile (file, res) {
      let vm = this
      let url = res && res[0] && res[0].upyunurl

      // 构造FormData对象并赋值
      let formData = new FormData()
      formData.append('policy', res[0].policy) // 后端接口压缩图片参数
      formData.append('signature', res[0].signature)
      formData.append('file', file)
      vm.fileUpload(url, formData, res)
    },

    // 上传后的图片插入到富文本内
    async insertPasteImg (url) {
      let vm = this
      if (url) {
        /* const chain2 = uploadConvert()
        await chain2
          .params({
            url
          })
          .onSuccess(payload => {
            const ins = vm.$refs.myQuillEditor.quill
            vm.addImgRange = ins.getSelection()
            ins.insertEmbed(
              ins.getSelection(),
              'image',
              payload
            )
          })
          .fetch() */
        const ins = vm.$refs.myQuillEditor.quill
        const index = (ins.getSelection() || {}).index || ins.getLength() - 1
        ins.insertEmbed(index, 'image', url, 'user')
        setTimeout(() => {
          ins.setSelection(index + 1)
        }, 0)

        this.imageLoading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.editor {
  width: 100%;
}
.quill-editor ::v-deep {
  margin: 12px 0;
  * {
    -webkit-user-select: text;
  }
  .ant-form-explain {
    line-height: 20px;
  }
  .ql-toolbar.ql-snow {
    line-height: 1;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-color: #ebebeb;
    overflow: auto;
  }

  .ql-container.ql-snow {
    height: calc(300px - 66px);
    max-height: 500px;
    overflow: scroll;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-color: #ebebeb;
  }
  .ql-toolbar.ql-snow .ql-formats {
    margin: 0;
  }

  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    width: 14px;
  }
  .ql-snow.ql-toolbar button svg,
  .ql-snow .ql-toolbar button svg {
    width: 14px;
  }

  .ql-editor {
    font-size: 16px;
    color: #333;
  }

  .ql-editor.ql-blank::before {
    color: #d6d6d6;
    font-style: normal;
  }
}
</style>
<style lang="scss">
.cube-toast {
  .cube-popup-content {
    height: 50px;
  }
}
</style>
